module.exports = __webpack_public_path__ + "img/how_logo.d787cf53.svg";